module.exports = __webpack_public_path__ + "img/T7S box 3 - EN.0d20110e.webp";